import { TOptions, StringMap } from 'i18next';
import { i18n } from 'next-i18next';

export const t = (
  key: string,
  optionsOne?: string | TOptions<StringMap>,
  optionsTwo?: string | TOptions<StringMap>,
): string => {
  if (i18n) {
    if (optionsTwo) {
      return i18n?.t(key, optionsOne as string, optionsTwo);
    }
    return i18n?.t(key, optionsOne);
  }
  if (typeof optionsOne === 'string') {
    return optionsOne;
  }
  return optionsOne?.defaultValue || '';
};
